// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fdc87c18","893":"fb2b9606","976":"f3cbee5e"}[chunkId] + ".chunk.js";
};